//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    product: { type: String, required: true },
    hideTitle: { type: Boolean, default: false },
    hidePrice: { type: Boolean, default: false },
    hideReviews: { type: Boolean, default: false },
    hideButtons: { type: Boolean, default: false }
  },
  data () {
    return {
      activeBestseller: 0
    }
  },
  computed: {
    bestsellers () { return this.$store.getters['product/bestsellers'](this.product) || [] },
    bestseller () {
      if (this.bestsellers.length < this.activeBestseller + 1) return {}
      return this.bestsellers[this.activeBestseller]
    },
    baseProduct () {
      return this.product.split('-')[0]
    },
    productDetails () { return this.$store.getters['product/productDetails'](this.baseProduct) || { details: {} } },
    rating () { return this.$store.getters['review/productRating'](this.baseProduct) },
    count () { return this.$store.getters['review/productCount'](this.baseProduct) },
    price () { return this.$store.getters['product/priceFromSku']((this.bestseller || {}).sku || '') },
    productName () { return this.$store.getters['product/productName']((this.bestseller || {}).sku || '', false) },
    allowLensTechFiltering () { return ['classics3', 'sierras', 'renegades'].includes(this.product) },
    minimumProductPrice () { return this.$store.getters['product/minimumProductPrice']((this.bestseller || {}).sku || '') }
  },
  methods: {
    async addToCart (sku) {
      // Get bundle config
      await this.$store.dispatch('cart/ADD_BY_SKU', sku)
    }
  }
}
